.container {
  text-align: center;
  position: relative;
}

.backArrow {
  background-color: white;
  border-radius: 9999px;
  padding: 8px;
  cursor: pointer;
}

.title {
  font-weight: bold;
}

.subtitle {
  font-size: 12px;
}

.content {
  display: grid;
  gap: 0.75rem;
  text-align: left;
  position: relative;
}

@media (min-width: 768px) {
  .content {
    grid-column: span 2 / span 2;
  }
}

.formGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  padding: 16px 0;
  height: 500px;
  overflow-y: auto;
}

@media (min-width: 768px) {
  .formGrid {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
}

.fullSpan {
  grid-column: span 2;
}

.textLeft {
  text-align: left;
  position: relative;
}

.errorText {
  font-size: 12px;
  color: red;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.reaction {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 0.5rem;
}

.button {
  padding: 0.5rem;
  border-radius: 0.5rem;
  transition: all;
  transition-duration: 300ms;
  cursor: pointer;
  border: none;
}
.button:active {
  transform: scale(95%);
  border: none;
}

.buttonGray {
  width: 40%;
  background-color: #ddd8d8;
  color: #241e1e;
  border: none;
}

.buttonRed {
  width: 40%;
  background-color: #d20000;
  color: white;
  border: none;
}

.feedbackStatus {
  padding-inline: 20px;
}

.emoji {
  padding: 0.25rem;
  background-color: #ddd8d8;
  border-radius: 50%;
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.emoji[aria-selected="true"] {
  background-color: bisque;
  border: none;
}
